// SITE CREDITS
console.log(
	"%cSite by View Source \n%cview-source.com",
	[
		"margin: 20px 0 0;",
		"font-size: 12px",
		"font-family: Helvetica, sans-serif",
		"font-weight: 700",
	].join(";"),
	[
		"margin: -5px 0 20px;",
		"font-size: 12px",
		"font-family: Helvetica, sans-serif",
		"font-weight: 400",
	].join(";")
);

// GLOBAL VARIABLES
(function () {
	let localTestKey = "test";
	let localStorage = window.sessionStorage;

	try {
		localStorage.setItem(localTestKey, 1);
		localStorage.removeItem(localTestKey);
		return localStorageName in win && win[localStorageName];
	} catch (e) {
		hasLocalStorage =
			e.code === DOMException.QUOTA_EXCEEDED_ERR && localStorage.length === 0
				? false
				: true;
	}
})();

let isTablet = 900 < innerWidth ? false : true;
let isMobile = 600 < innerWidth ? false : true;

window.addEventListener("resize", () => {
	isTablet = 900 < innerWidth ? false : true;
	isMobile = 600 < innerWidth ? false : true;
});

// OUTPUTS
const getRandomInt = (min, max) => {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min)) + min;
};

const getIntSuffix = (num = 1) => {
	let suffix = "th";
	if (num == 0) suffix = "";
	if (num % 10 == 1 && num % 100 != 11) suffix = "st";
	if (num % 10 == 2 && num % 100 != 12) suffix = "nd";
	if (num % 10 == 3 && num % 100 != 13) suffix = "rd";

	return num + suffix;
};

const getOffset = (el) => {
	let elBounding = el.getBoundingClientRect();

	return {
		top: elBounding.top + scrollY,
		left: elBounding.left + scrollX,
	};
};

// FORMATTING
const formatLeadingZero = (val) => {
	return (val < 10 ? "0" : "") + val;
};

const formatHandleize = (str) => {
	return str
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/-$/, "")
		.replace(/^-/, "");
};

function unslugify(slug) {
	return slug
		.replace(/[-_]+/g, " ") // Replace dashes and underscores with space
		.replace(/\s+/g, " ") // Normalize multiple spaces
		.trim() // Remove leading/trailing spaces
		.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
}

const formatPad = (val, length = 2, char = 0) => {
	// example, leading zero: 8 = "08",
	// example, password: 000088885581 = "********5581"
	return val.toString().padStart(length, char);
};

const formatClamp = (value, min = 0, max = 1) => {
	// example, formatClamp(999, 0, 300) = 300
	return value < min ? min : value > max ? max : value;
};

const formatNumberCommas = (string) => {
	// example, formatNumberWithCommas(3000.12) = 3,000.12
	const parts = string.toString().split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

	return parts.join(".");
};

const formatNumberEuro = (string) => {
	// example, formatNumberEuro(3000.12) = 3 000,12
	const parts = string.toString().split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");

	return parts.join(",");
};

const formatDateUsStandard = (date) => {
	return [
		formatPad(date.getDate()),
		formatPad(date.getMonth() + 1),
		date.getFullYear(),
	].join("/");
};

// ACTIONS

let scrollPosition = 0;

const scrollDisable = () => {
	document.documentElement.style.overflow = "hidden";

	// if (window.matchMedia('(any-hover: none)').matches) {
	// 	document.body.style.overflow = 'hidden';
	// }
};

const scrollEnable = () => {
	document.documentElement.style.overflow = "initial";

	// if (window.matchMedia('(any-hover: none)').matches) {
	// 	document.body.style.overflow = 'initial';
	// }
};

const parseHtmlString = (htmlString) => {
	const parser = new DOMParser();
	return parser.parseFromString(htmlString, "text/html");
};

const validateEmail = (email) => {
	if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
		return true;
	}

	return false;
};

const validatePhoneNumber = (phone) => {
	if (/^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(phone)) {
		return true;
	}

	return false;
};

// event delegation
// example; on('body', 'click', '.accordion-toggle, .accordion-toggle *', e => {…});
const on = (selector, eventType, childSelectors, eventHandler) => {
	let _childSelectors = childSelectors.split(",");
	let elements = document.querySelectorAll(selector);

	for (element of elements) {
		element.addEventListener(eventType, (eventOnElement) => {
			_childSelectors.forEach((selector) => {
				if (
					eventOnElement.target.matches(selector) ||
					eventOnElement.target.closest(selector)
				) {
					eventHandler(eventOnElement);
				}
			});
		});
	}
};

const slide = (action, el, duration = 400) => {
	const slideDown = () => {
		let childrenHeight = Object.values(el.children).reduce(
			(total, i) => total + i.offsetHeight,
			0
		);

		// Apply active state
		el.classList.add("is-active");
		el.style.height = "auto";

		// Set the height of the content as 0px
		// so we can trigger the slide down animation.
		el.style.height = "0px";

		// Do this after the 0px has applied.
		// It's like a delay or something. MAGIC!
		setTimeout(() => {
			el.style.height = `${childrenHeight}px`;
			el.style.transition = `height ${duration}ms`;
		}, 0);
	};

	const slideUp = () => {
		// Set the height as 0px to trigger the slide up animation.
		el.classList.remove("is-active");
		el.style.height = "0px";
		el.style.transition = `height ${duration}ms`;

		// Remove the active state when the animation ends
		el.addEventListener(
			"transitionend",
			() => {
				el.style.transition = `0s`;
			},
			{ once: true }
		);
	};

	switch (action) {
		case "down":
			slideDown();
			break;

		case "up":
			slideUp();
			break;

		case "toggle":
			!el.classList.contains("is-active") ? slideDown() : slideUp();
			break;
	}
};

function getSiblings(elem) {
	return Array.from(elem.parentNode.children).filter(function (sibling) {
		return sibling !== elem;
	});
}

function setAttributes(element, attributes) {
	Object.keys(attributes).forEach((attr) => {
		element.setAttribute(attr, attributes[attr]);
	});
}

function removeAttributes(element, attributes) {
	attributes.forEach((attr) => {
		element.removeAttribute(attr);
	});
}
let timerId;
function debounce(func, delay) {
	// Cancels the setTimeout method execution
	clearTimeout(timerId);

	// Executes the func after delay time.
	timerId = setTimeout(func, delay);
}

function changeTimeZone(date, timeZone) {
	if (typeof date === "string") {
		return new Date(
			new Date(date).toLocaleString("en-US", {
				timeZone,
			})
		);
	}

	return new Date(
		date.toLocaleString("en-US", {
			timeZone,
		})
	);
}

function formatAMPM(date) {
	var hours = date.getHours();
	var minutes = date.getMinutes();
	var ampm = hours >= 12 ? "pm" : "am";
	hours = hours % 12;
	hours = hours ? hours : 12; // the hour '0' should be '12'
	minutes = minutes < 10 ? "0" + minutes : minutes;
	var strTime = hours + ":" + minutes + " " + ampm;
	return strTime;
}

function dateDiff(d1str, d2str) {
	var d1 = new Date(d1str),
		d2 = new Date(d2str);
	return (d2.getTime() - d1.getTime()) / 1000 / 60 / 60 / 24; // diff in days
}

function throttle(callback, delay) {
	let previousCall = 0;
	return function (...args) {
		const time = new Date().getTime();
		if (time - previousCall >= delay) {
			previousCall = time;
			callback.apply(null, args);
		}
	};
}

function getAuthToken() {
	const username = "devviewsourcecom";
	const password = "vcSnJ6TuIkAsasZZSsoS";
	return btoa(`${username}:${password}`);
}

const validateJson = (string) => {
	try {
		return JSON.parse(string);
	} catch (e) {
		console.error("JSON parse error:", e);
		return false;
	}
};

const loader = {
	// Adds a new loader to an element
	new: function (el, start = false) {
		const div = document.createElement("div");
		div.classList.add("loader");
		el.appendChild(div);
		el.dataset.loader = getRandomInt(0, 999999);

		if (start) this.updateProgress(el);
	},
	// Update loader progress and animate progress bar
	updateProgress: function (el) {
		const loader = el.querySelector(".loader");
		if (!loader) {
			this.new(el, true);
		} else {
			const startingProgress = getRandomInt(10, 30);
			el.dataset.loaderProgress = startingProgress;
			loader.style.transform = `scaleX(${startingProgress / 100})`;

			const loadingBarMove = setInterval(() => {
				const currentProgress = parseInt(el.dataset.loaderProgress);
				const isCompleted = currentProgress == 101;

				if (isCompleted) {
					clearInterval(loadingBarMove);
				} else {
					const newProgress = currentProgress + getRandomInt(5, 10);
					const shouldComplete = newProgress >= 100;

					if (shouldComplete) {
						this.complete(el);
					} else {
						el.dataset.loaderProgress = newProgress;
						loader.style.transform = `scaleX(${newProgress / 100})`;
					}
				}
			}, 1000);
		}
	},
	// Completes loader progress and hides loader
	complete: function (el) {
		const loader = el.querySelector(".loader");
		el.dataset.loaderProgress = 100;
		loader.style.transform = `scaleX(1)`;

		setTimeout(() => {
			el.dataset.loaderProgress = 101;
			loader.style.transform = `scaleX(0)`;
		}, 400);
	},

	// Initiate existing loaders and add loader to root
	init: function () {
		const elWithLoaders = document.querySelectorAll("[data-loader]");

		// elWithLoaders?.forEach((el) => {
		// 	this.new(el);
		// });
		this.new(root);
	},
};

//Member only experience
// Archive this
// const updateProductForm2024 = async (productForms, variantUrl = null) => {
// 	root.classList.add("is-fetching-product-form");
// 	const currentUrl = window.location.href;
// 	const url = new URL(currentUrl);
// 	const pathAndQuery = variantUrl
// 		? variantUrl
// 		: url.pathname + url.search + url.hash;

// 	const cartHasMembership = root.classList.contains("cart-has-membership");
// 	const isLoggedInMember = root.classList.contains("is-login-member");
// 	const isMembersOnly = root.classList.contains("is-members-only");

// 	await fetch(pathAndQuery)
// 		.then((res) => {
// 			return res.text();
// 		})
// 		.then((data) => {
// 			let parser = new DOMParser();
// 			let dataHtml = parser.parseFromString(data, "text/html");
// 			const targetSubmit = dataHtml.querySelector("[data-members-only-form]");
// 			const productPills = document.querySelector(
// 				".product-hero__content__pills"
// 			);
// 			const productContent = document.querySelector(
// 				".product-hero__content__interior"
// 			);
// 			const productPillsHtml = dataHtml.querySelector(
// 				".product-hero__content__pills"
// 			);

// 			// Replace pdp pills
// 			if (productPillsHtml) {
// 				productPills?.remove();
// 				productContent.prepend(productPillsHtml);
// 			} else {
// 				productPills?.remove();
// 			}

// 			productForms.forEach((form) => {
// 				const currentSubmit = form.querySelector("[data-members-only-form]");
// 				const formFooter = form.querySelector(".c-product-form__footer");
// 				const formBackInStock = document.querySelector(
// 					'form[action="back_in_stock"]'
// 				);
// 				const formVariants = form.querySelector(".c-product-form__variants");
// 				const formPrice = form.querySelector(".c-product-form__price");
// 				const formQuantity = form.querySelector(".c-product-form__quantity");

// 				//conditionally hides variant, price, quantity and bis based on members only
// 				formBackInStock?.classList.toggle(
// 					"is-hidden",
// 					isMembersOnly && !cartHasMembership && !isLoggedInMember
// 				);

// 				[formVariants, formPrice, formQuantity].forEach((element) => {
// 					if (!isMembersOnly) {
// 						element.classList.remove("is-hidden");
// 					} else if (element && cartHasMembership && isMembersOnly) {
// 						element.classList.remove("is-hidden");
// 					} else if (
// 						element &&
// 						!cartHasMembership &&
// 						!isLoggedInMember &&
// 						isMembersOnly
// 					) {
// 						element.classList.add("is-hidden");
// 					}
// 				});

// 				if (targetSubmit && formFooter) {
// 					//only run on color swatch change
// 					currentSubmit.remove();
// 					formFooter.appendChild(targetSubmit);
// 					root.classList.remove("is-fetching-product-form");
// 				}
// 			});
// 		})
// 		.catch((error) => {
// 			console.error("Error:", error);
// 		});
// };
const updateProductForm = async (productForms, variantUrl = null) => {
	root.classList.add("is-fetching-product-form");
	const currentUrl = window.location.href;
	const url = new URL(currentUrl);
	const pathAndQuery = variantUrl
		? variantUrl
		: url.pathname + url.search + url.hash;

	const cartHasMembership = root.classList.contains("cart-has-membership");
	const isLoggedInMember = root.classList.contains("is-login-member");
	const isMembersOnly = root.classList.contains("is-members-only");

	await fetch(pathAndQuery)
		.then((res) => {
			return res.text();
		})
		.then((data) => {
			let parser = new DOMParser();
			let dataHtml = parser.parseFromString(data, "text/html");
			const targetSubmit = dataHtml.querySelectorAll(
				"[data-members-only-form]"
			);

			productForms.forEach((form, index) => {
				const currentSubmit = form.querySelector("[data-members-only-form]");
				const targetSubmitWrapper = form.querySelector(".c-product-form__add");
				const backInStockForm = document.querySelector(
					'form[action="back_in_stock"]'
				);

				const shouldHideBackInStock =
					isMembersOnly && !cartHasMembership && !isLoggedInMember;

				//conditionally hide bis based on members only
				if (shouldHideBackInStock) {
					backInStockForm?.classList.remove("is-active");
					setTimeout(() => {
						backInStockForm?.classList.add("is-hidden");
					}, 400);
				} else {
					backInStockForm?.classList.remove("is-hidden");
				}

				// Replace submit button only on color swatch change
				if (targetSubmit[index] && targetSubmitWrapper) {
					currentSubmit.remove();
					targetSubmitWrapper.append(targetSubmit[index]);
					root.classList.remove("is-fetching-product-form");
				}
			});
		})
		.catch((error) => {
			console.error("Error:", error);
		});
};

const updateProductCards = async (productCards, productCardsSearch) => {
	const currentUrl = window.location.href;
	const url = new URL(currentUrl);
	const pathAndQuery = url.pathname + url.search + url.hash;

	await fetch(pathAndQuery)
		.then((res) => {
			return res.text();
		})
		.then((data) => {
			let parser = new DOMParser();
			let dataHtml = parser.parseFromString(data, "text/html");

			// Get all the quick add buttons that need to be updated.
			const productCardsHtml = Array.from(
				dataHtml.querySelectorAll("[data-member-only-card] .js-card-quick-add")
			);

			const updateQuickAddContent = (elements) => {
				elements.forEach((el, index) => {
					if (productCardsHtml[index]) {
						el.innerHTML = productCardsHtml[index].innerHTML;
					}
				});
			};

			//update live search and all product cards
			updateQuickAddContent(productCardsSearch);
			updateQuickAddContent(productCards);
		})
		.catch((error) => {
			console.error("Error:", error);
		});
};

const updateProductFormsCards = () => {
	const productForms = document.querySelectorAll(".c-product-form");

	//prevent live search results card
	const productCards = document
		.querySelector("main")
		.querySelectorAll("[data-member-only-card] .js-card-quick-add");

	const productCardsSearch = document
		.querySelector(".global-search")
		.querySelectorAll("[data-member-only-card] .js-card-quick-add");

	if (productForms.length > 0) {
		updateProductForm(productForms);
	}

	if (productCards.length > 0) {
		updateProductCards(productCards, productCardsSearch);
	}
};

const updateAllLimitedPurchaseForms = (targetForm) => {
	const targetFormId = targetForm.dataset.formId;
	document
		.querySelectorAll(`.c-product-form[data-form-id="${targetFormId}"]`)
		.forEach((form) => {
			form.classList.toggle("is-purchased");

			const cartAddButton =
				form.querySelector("[data-cart-add-id]") ||
				form.querySelector(".js-form-submit");

			if (cartAddButton && form.dataset?.available === "true") {
				cartAddButton.disabled = form.classList.contains("is-purchased");
			}
		});
};
